<template>
  <div>
    <b-card title="Origens">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :to="{ name: 'admin-origin-register' }"
      >
        <feather-icon icon="PlusIcon" />
        Adicionar
      </b-button>
      <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      variant="flat-primary"
      @click="reportData"
    >
      <feather-icon icon="FileTextIcon" />
      Exportar
    </b-button>
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="false"
        :hasSyncButton="true"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
        @onSync="onSync"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard } from "bootstrap-vue";
// import CustomTable from "@/views/custom/table/CustomTable.vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import originService from "@/providers/originService";
import AppConstants from "@/appConstants";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import dropdownService from '@/providers/dropdownService';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BButton,
    BCard,
    CustomGTable,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        { field: "name", label: "Nome", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome', trigger: 'enter' } },
        { field: "code", label: "Código", sortable: false, filterOptions: { filterValue: '', enabled: true, numeric: true, placeholder: 'Pesquisar por código', trigger: 'enter' } },
        { field: "channel", label: "Canal", type: 'array', sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por canal', filterDropdownItems: [] } },
        // { field: "redis_queue", label: "Redis Queue", sortable: false },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por data', trigger: 'enter' } },
        { field: "active", label: "Habilitado", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por ativo', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
        { field: "displayInSendNews", label: "Mostrar envio de noticia", type: "boolean", sortable: false },
        { field: "legacy", label: "Legado", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por legado', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
      ],
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Origem');
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append('page', this.page);
      params.append('limit', this.limit);
      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      originService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "origens.xlsx");
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onFilter(data) {
      // this.filter = data;
      // console.log("OnFilter: ", this.filter);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_ORIGIN_REGISTER}/${data._id}`
      );
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onSync(data) {
      console.log(data);
      if (data.sync_origin_adv) {
        messageDialogHelper.displayConfirmMessage(
          "Sincronização",
          `Gostaria de sincronizar a origem ${data.name} código ${data.code}?`,
          () => {
            const params = new URLSearchParams();
            originService
              .syncOrigin(data._id, params)
              .then(() => {
                console.log("sincronizado com sucesso");
                messagesNotifyHelper.successNotify(
                  "Sincronização",
                  "Sincronização feita com sucesso"
                );
              })
              .catch((err) => {
                console.log(err);
              });
          }
        );
      } else {
        messagesNotifyHelper.errorNotify(
          "Sincronização",
          "Origem não habilitado para sincronziação com advanced"
        );
      }
      
    },
    onDelete(data) {
      console.log(data);
      const params = new URLSearchParams();
      originService
        .deleteOrigin(data._id, params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(() => {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadDataFilter() {
      dropdownService
        .getChannel(new URLSearchParams())
        .then((res) => {
          const channel = res.map(item => {
            return { value: item.id, text: item.name };
          });
          this.fields[this.fields.findIndex(item => item.field=='channel')].filterOptions.filterDropdownItems = channel;
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', originService.getAllOrigin(this.searchParams))
        .then((res) => {
          console.log(res);
          this.displayTable = true;
          this.totalRows = res.totalRows;
          this.data = res.data;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>